@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Suppress
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import com.varabyte.kobweb.showcase.site.ui.components.layouts.PageLayout as _com_varabyte_kobweb_showcase_site_ui_components_layouts_PageLayout
import com.varabyte.kobweb.showcase.site.ui.pages.ShowcasePage as _com_varabyte_kobweb_showcase_site_ui_pages_ShowcasePage
import com.varabyte.kobweb.showcase.site.ui.pages.SubmitPage as _com_varabyte_kobweb_showcase_site_ui_pages_SubmitPage

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Kobweb Showcase", "SHOWCASE_DATA_URL" to "https://raw.githubusercontent.com/varabyte/kobweb-showcase-db/refs/heads/main/resources/db/showcased-sites.json"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.registerLayout(
            "com.varabyte.kobweb.showcase.site.ui.components.layouts.PageLayout",
        ) { pageCtx, pageMethod -> 
            _com_varabyte_kobweb_showcase_site_ui_components_layouts_PageLayout(pageCtx) {
                pageMethod(pageCtx)
            }
        }
        ctx.router.register(
            "/",
            layoutId = "com.varabyte.kobweb.showcase.site.ui.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.varabyte.kobweb.showcase.site.ui.pages.initShowcasePage(ctx)
            },
        ) { pageCtx -> 
            _com_varabyte_kobweb_showcase_site_ui_pages_ShowcasePage()
        }
        ctx.router.register(
            "/submit",
            layoutId = "com.varabyte.kobweb.showcase.site.ui.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.varabyte.kobweb.showcase.site.ui.pages.initSubmitPage(ctx)
            },
        ) { pageCtx -> 
            _com_varabyte_kobweb_showcase_site_ui_pages_SubmitPage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("site-name-text", com.varabyte.kobweb.showcase.site.ui.components.sections.SiteNameTextStyle)
        ctx.theme.registerStyle("hero-primary-box", com.varabyte.kobweb.showcase.site.ui.components.sections.HeroPrimaryBoxStyle)
        ctx.theme.registerStyle("hero-note-box", com.varabyte.kobweb.showcase.site.ui.components.sections.HeroNoteBoxStyle)
        ctx.theme.registerStyle("page-content", com.varabyte.kobweb.showcase.site.ui.components.layouts.PageContentStyle)
        ctx.theme.registerStyle("showcase-card", com.varabyte.kobweb.showcase.site.ui.components.widgets.showcasecard.ShowcaseCardStyle)
        ctx.theme.registerStyle("skeleton-base", com.varabyte.kobweb.showcase.site.ui.components.widgets.showcasecard.SkeletonBaseStyle)
        ctx.theme.registerStyle("card-image-wrapper", com.varabyte.kobweb.showcase.site.ui.components.widgets.showcasecard.CardImageWrapperStyle)
        ctx.theme.registerStyle("card-image", com.varabyte.kobweb.showcase.site.ui.components.widgets.showcasecard.CardImageStyle)
        ctx.theme.registerStyle("expanded-overlay", com.varabyte.kobweb.showcase.site.ui.components.widgets.showcasecard.ExpandedOverlayStyle)
        ctx.theme.registerStyle("expanded-card", com.varabyte.kobweb.showcase.site.ui.components.widgets.showcasecard.ExpandedCardStyle)
        ctx.theme.registerStyle("basic-tag", com.varabyte.kobweb.showcase.site.ui.components.widgets.showcasecard.BasicTagStyle)
        ctx.theme.registerStyle("official-tag", com.varabyte.kobweb.showcase.site.ui.components.widgets.showcasecard.OfficialTagStyle)
        ctx.theme.registerStyle("external-link-btn", com.varabyte.kobweb.showcase.site.ui.components.widgets.showcasecard.ExternalLinkBtnStyle)
        ctx.theme.registerStyle("headline-text", com.varabyte.kobweb.showcase.site.ui.styles.HeadlineTextStyle)
        ctx.theme.registerStyle("subheadline-text", com.varabyte.kobweb.showcase.site.ui.styles.SubheadlineTextStyle)
        ctx.theme.registerStyle("footer", com.varabyte.kobweb.showcase.site.ui.styles.FooterStyle)
        ctx.theme.registerStyle("nav-header", com.varabyte.kobweb.showcase.site.ui.styles.NavHeaderStyle)
        ctx.theme.registerVariant("-circle", com.varabyte.kobweb.showcase.site.ui.styles.CircleButtonVariant)
        ctx.theme.registerVariant("-uncolored", com.varabyte.kobweb.showcase.site.ui.styles.UncoloredButtonVariant)
        ctx.theme.registerKeyframes("side-menu-slide-in", com.varabyte.kobweb.showcase.site.ui.components.sections.SideMenuSlideInAnim)
        ctx.theme.registerKeyframes("shimmer", com.varabyte.kobweb.showcase.site.ui.components.widgets.showcasecard.ShimmerAnim)
        ctx.theme.registerKeyframes("glint", com.varabyte.kobweb.showcase.site.ui.components.widgets.showcasecard.GlintAnim)
        com.varabyte.kobweb.showcase.site.ui.theme.initTheme(ctx)
        com.varabyte.kobweb.showcase.site.ui.styles.initSiteStyles(ctx)
        com.varabyte.kobweb.showcase.site.initGlobalStyles(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        com.varabyte.kobweb.showcase.site.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
